import { ArrowDownIcon } from 'lucide-react';
import { fmt } from '../insightFormat';
import type { FunnelRow } from '../../../core/rules/insights/funnel';

/**
 * De trechter van productpagina tot betaald. Elke stap een balk naar verhouding van de eerste;
 * tussen de stappen hoeveel er doorging. Een stap uit een andere bron krijgt een *.
 */
export function FunnelChart({
  rows
}: {
  rows: FunnelRow[];
}) {
  const first = Math.max(1, rows[0]?.count ?? 1);
  return <ol className="space-y-1" data-id="element-1800" data-mp="2erevb5if366r">
      {rows.map((r, i) => <li key={r.key} data-id="element-1801" data-mp="2jpyjzdoeaw2t" data-mpi={i}>
          {i > 0 && <p className="flex items-center gap-1.5 py-1 pl-1 text-[12px] text-muted" data-id="element-1802" data-mp="2jondv77h9c8j">
              <ArrowDownIcon className="h-3 w-3" strokeWidth={2} aria-hidden="true" data-id="element-1803" data-mp="2oi9tn88xtw8k" />
              {r.fromPrevious === null ? 'Te weinig om te zeggen' : `${fmt(r.fromPrevious, 'pct')} ging door`}
              {r.mixed && <span data-id="element-1804" data-mp="2xg1zzmwoltjt">*</span>}
            </p>}
          <div className="flex items-baseline justify-between gap-3 text-[13px]" data-id="element-1805" data-mp="32gg62zeq2tf7">
            <span className="text-ink" data-id="element-1806" data-mp="vjslxq80wehi">
              {r.label}
              {r.mixed && <span className="text-muted" data-id="element-1807" data-mp="qk68pgs72y8p">*</span>}
            </span>
            <span className="tabular-nums text-ink" data-id="element-1808" data-mp="qiv45eqxdmgj">
              {fmt(r.count)}
              {r.fromStart !== null && <span className="ml-1.5 text-muted" data-id="element-1809" data-mp="mkp1aht7jr0w">{fmt(r.fromStart, 'pct')} van het begin</span>}
            </span>
          </div>
          <div className="mt-1 h-2.5 overflow-hidden rounded-sm bg-sand" data-id="element-1810" data-mp="1e9is19h8kmoq">
            <div className={`h-full rounded-sm ${r.source === 'orders' ? 'bg-sage' : 'bg-clay/75'}`} style={{
          width: `${Math.max(1, Math.min(100, r.count / first * 100))}%`
        }} data-id="element-1811" data-mp="1ebv9llj30v19" />
          </div>
        </li>)}
    </ol>;
}